
import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Filter, FilterService } from '@spotter/services/sightings/filter-service';
import { ResearchGradeComponent } from '../research-grade/research-grade.component';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'filter-panel',
    templateUrl: './filter-panel.component.html',
    styleUrls: ['./filter-panel.component.scss'],
    imports: [TranslatePipe, ResearchGradeComponent, FormsModule]
})
export class FilterPanelComponent {

    @Input() filter!: Filter;



    constructor(public filterController: FilterService)
    {

    }

}
